<template>
  <form-select
    class="brand-select"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'brand-select-v1',
  props: {
    lang: String,
    category: String,
    value: [String, Number],
    profile: String,
    packid: String,
    version: String,
    area: String,
    changeIndex: Number
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      }
    },
    hasExtParam() {
      return this.packid && this.version
    }
  },
  data() {
    return {
      options: [],
      vermap: {}
    }
  },
  // created() {
  //   this.getBrand()
  // },
  methods: {
    getBrand() {
      var options = []
      this.val = null
      this.options = []
      this.vermap = {}
      this.$post('view/getBrandSpecial', {
        category: this.category,
        lang: this.lang,
        profile: this.profile,
        area: this.area,
        packid: this.packid,
        version: this.version,
        ignoreArea: true
      })
        .then((resp) => {
          if (resp.data.code == 0 && resp.data.data.length > 0) {
            for (var item of resp.data.data) {
              //品牌去重(一个packid可能对应多个版本)
              if (this.vermap[item.brand]) {
                this.vermap[item.brand].push(item.version)
              } else {
                this.vermap[item.brand] = [item.version]
                options.push(
                  Object.assign(
                    {
                      label: item.brand,
                      value: item.brand
                    },
                    item // 关联具体配置时，对应一个品牌，只有一个诊断包(packid)
                  )
                )
              }
            }
            this.options = options
            if (options.length > 0) {
              let defaultOption = options[0]
              // 默认选中第一项，如果是从产品详情页跳转值功能表页面，则根据packid,version匹配默认选中项
              if (this.hasExtParam) {
                defaultOption = options.find(
                  (f) => parseFloat(f.version) == parseFloat(this.version)
                )
                if (!defaultOption) {
                  defaultOption = options[0]
                }
              }
              if (defaultOption) {
                this.val = defaultOption.value
                const currentBrand = Object.assign({
                  profile: this.profile,
                  brand: defaultOption.brand,
                  packid: defaultOption.packid,
                  version: defaultOption.version
                })
                this.$nextTick(() => {
                  this.$emit(
                    'outVersion',
                    currentBrand,
                    this.vermap[currentBrand.brand]
                  )
                })
              }
            }
          } else {
            this.$message('获取品牌失败')
            this.$nextTick(() => {
              this.$emit('outVersion', [])
            })
          }
        })
        .catch((error) => {
          this.$message('获取品牌发生错误=>' + error)
        })
    },
    change(newVal) {
      const currentOption = this.options.find((f) => f.brand == newVal)
      const currentBrand = {
        profile: this.profile,
        brand: newVal,
        packid: currentOption.packid,
        version: ''
      }
      let versions = this.vermap[newVal]
      versions.sort((a, b) => (a.brand < b.brand ? -1 : 1))
      this.$nextTick(() => {
        this.$emit('outVersion', currentBrand, versions)
      })
    }
  },
  watch: {
    packid() {
      this.getBrand()
    },
    version() {
      this.getBrand()
    },
    profile() {
      this.getBrand()
    }
  }
}
</script>
<style lang="less">
.brand-select {
  width: 100px;
}
</style>
